export const visibilityOptionPublic = 'public';
export const visibilityOptionPrivate = 'private';
export const visibilityOptions = [
  {
    description: 'Public',
    value: visibilityOptionPublic,
  },
  {
    description: 'Private',
    value: visibilityOptionPrivate,
  },
];

export const genderOptions = [
  {
    description: 'Male',
    value: 'male',
  },
  {
    description: 'Female',
    value: 'female',
  },
  {
    description: 'Non-binary/Non-conforming',
    value: 'non-binary',
  },
  {
    description: 'No preferences',
    value: 'none',
  },
];

export const ageOptions = [
  {
    description: '18-25',
    value: '18-25',
  },
  {
    description: '25-35',
    value: '25-35',
  },
  {
    description: '35-45',
    value: '36-45',
  },
  {
    description: '45+',
    value: '45+',
  },
  {
    description: 'I dont mind',
    value: 'none',
  },
];

export const ndisRegisteredOptions = [
  {
    description: 'No preferences',
    value: 'no preferences',
  },
  {
    description: 'Yes',
    value: 'yes',
  },
  {
    description: 'No',
    value: 'no',
  },
];

export const carOwnershipOptions = [
  {
    description: 'Car and Licence',
    value: 'car_and_license',
  },
  {
    description: 'Licence only',
    value: 'license_only',
  },
  {
    description: 'None',
    value: 'none',
  },
];
